/**
 * Les deux espaces de l'application : Ma visibilité pour les établissements,
 * Mes échanges pour les offices de tourisme.
 */
export enum Space {
  PILOTAGE = "pilotage",
  DIALOGUE = "dialogue",
}

export enum DestinationProviderScope {
  DIALOGUE = "dialogue",
  PILOTABLE = "pilotable",
}
